import { createFileRoute } from '@tanstack/react-router'

import { UsersPage } from '@/components/UsersPage'
import { withTitle } from '@/utils/withTitle.ts'

export const Route = createFileRoute('/_app/users')({
  component: UsersPage,
  head: withTitle('Users Overview'),
})
